import React from 'react';
import { Link } from 'react-router-dom';
import { Check, ArrowRight } from 'lucide-react';
import { SiteSection, SiteSectionHeader } from '../../../../components/site';
import { platformModules } from '../data/overview';

const modulePaths: Record<string, string> = {
  'iot-cloud': '/platform/iot-cloud',
  'firmware-sdk': '/platform/firmware-sdk',
  'mobile-apps': '/platform/mobile-apps',
  'partner-dashboard': '/platform/dashboard',
};

export const PlatformModules: React.FC = () => (
  <SiteSection tone="muted" className="platform-modules-section">
    <SiteSectionHeader
      eyebrow="Core modules"
      title="Core Platform Modules"
      subtitle="Everything you need to launch, operate, and scale a smart device brand"
      align="center"
    />
    <div className="platform-modules">
      {platformModules.map((mod) => (
        <article key={mod.id} id={mod.id} className="platform-module-card">
          <h3 className="platform-module-card__title">{mod.title}</h3>
          <p className="platform-module-card__desc">{mod.description}</p>
          <ul className="platform-module-card__features">
            {mod.features.map((feature) => (
              <li key={feature}>
                <Check size={16} strokeWidth={2.5} aria-hidden />
                <span>{feature}</span>
              </li>
            ))}
          </ul>
          {modulePaths[mod.id] ? (
            <Link to={modulePaths[mod.id]} className="platform-module-card__link">
              Learn more
              <ArrowRight size={16} aria-hidden />
            </Link>
          ) : null}
        </article>
      ))}
    </div>
  </SiteSection>
);
